import React from 'react';

import ImageView, { IMAGE_WIDTH, IMAGE_HEIGHT } from '../image_view';

import CacheWrapper from './cache_wrapper';

import { COLOR } from '../../../constants/styles';

export { IMAGE_WIDTH, IMAGE_HEIGHT };

export default class CachedImage extends React.Component {
  constructor(props) {
    super(props);

    this._imageViewRef = React.createRef();
  }

  shouldComponentUpdate(nextProps) {
    // designed to work with generic file objects that are attached to entities
    // such as events
    return this.props.attachment !== nextProps.attachment;
  }

  resetZoomSize() {
    this._imageViewRef?.current?.resetZoomSize();
  }

  setUri = (imageUri) => {
    this._imageViewRef?.current?.setImageUri(imageUri);
  };

  handleUriError = () => {
    this._imageViewRef?.current?.setImageUri(null);
  };

  handlePress = () => {
    this.props.onPress && this.props.onPress(this.props.attachment);
  };

  // Note that we use the setImageUri method on ImageView rather than binding
  // it to local state, so that way we will not trigger a render on this component

  // we are triggering the read from cache, / download from server on render
  // since the download URL's are short lived

  render() {
    const { attachment, isThumb, onPress, ...imageProps } = this.props;

    return (
      <CacheWrapper
        attachment={attachment}
        isThumb={isThumb}
        onUri={this.setUri}
        onError={this.handleUriError}
      >
        <ImageView
          ref={this._imageViewRef}
          loading={true}
          onPress={!!onPress ? this.handlePress : null}
          {...imageProps}
        />
      </CacheWrapper>
    );
  }
}
